import React, { useEffect } from "react";
import { Input, DatePicker } from "antd";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { MODULES_LIST } from "@/util/common_variable";

const QuickSearchBookings = ({ path }) => {
  useEffect(() => {
    console.log(path);
  }, [path]);
  return (
    <>
      {path === MODULES_LIST.BOOKINGS && (
        <>
          <StyledSectionHeading>
            <span>Booking Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol>
              <FormItem name="arrestDate" label="Arrest Date">
                <CommonDatePicker
                  showTime={false}
                  format="MM/DD/YYYY"
                  style={{ maxWidth: "130px" }}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="jacketId" label="Folder ID">
                <TextField style={{ maxWidth: "120px" }} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="custodyStatus" label="Custody Status">
                <Select
                  options={[
                    { value: "In Custody", label: "In Custody" },
                    { value: "Scheduled", label: "Scheduled" },
                    { value: "Released", label: "Released" },
                  ]}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="incarcerationDate" label="Incarceration Date">
                <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem
                name="justBookingsForAgency"
                label="Just Bookings for agency?"
                valuePropName="checked"
              >
                <Checkbox />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      <StyledSectionHeading>
        <span>
          {" "}
          {path === MODULES_LIST.STAFF
            ? "Staff Information"
            : "Biographical Information"}
        </span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <StyledGridCol>
          <FormItem name="lName" label="Last Name">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol>
          <FormItem name="fName" label="First Name">
            <TextField />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol>
          <FormItem name="mName" label="Middle Name">
            <TextField />
          </FormItem>
        </StyledGridCol>
        {path === MODULES_LIST.BOOKINGS && (
          <>
            <StyledGridCol>
              <FormItem name="dob" label="DOB">
                <CommonDatePicker format="MM/DD/YYYY" showTime={false} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="ssn" label="Social Security Number">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="dlNumber" label="Driver's License">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="pinNo" label="Old CRH#">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="sid" label="SID">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="aliases" label="Alias">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="race" label="Race">
                <Select options={getOptionsFromRefList("Race")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="gender" label="Gender">
                <Select options={getOptionsFromRefList("Gender")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Height +/-">
                <StyledFlex>
                  <FormItem name="height" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="heightPlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Weight +/-">
                <StyledFlex>
                  <FormItem name="weight" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="weightPlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem label="Age +/-">
                <StyledFlex>
                  <FormItem name="ageAtEntry" noStyle>
                    <TextField style={{ maxWidth: "110px" }} type="number" />
                  </FormItem>
                  <FormItem name="agePlusOrMinus" noStyle>
                    <TextField style={{ maxWidth: "75px" }} type="number" />
                  </FormItem>
                </StyledFlex>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="hair" label="Hair">
                <Select options={getOptionsFromRefList("hair")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="eyes" label="Eyes">
                <Select options={getOptionsFromRefList("eyes")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="glasses" label="Glasses">
                <Select options={getOptionsFromRefList("glasses")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="hairLength" label="H Length">
                <Select options={getOptionsFromRefList("hair_Length")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="facialHair" label="Face H.">
                <Select options={getOptionsFromRefList("facial_Hair")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="complexion" label="Complexion">
                <Select options={getOptionsFromRefList("complexion")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="ethnicity" label="Ethnicity">
                <Select options={getOptionsFromRefList("ethnicity")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="imageType" label="Image Type">
                <Select options={getOptionsFromRefList("Image_Type")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="juvenile" label="Juveniles">
                <Select
                  options={getOptionsFromRefList("BioQuickSearchJuveniles")}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="characteristicType" label="Dist. Char. Type">
                <Select
                  options={getOptionsFromRefList(
                    "DistinguishingCharacteristics"
                  )}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="description" label="Dist. Char. Description">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol>
              <FormItem name="characteristicLocation" label="Location">
                <Select
                  options={getOptionsFromRefList("CharacteristicLocation")}
                />
              </FormItem>
            </StyledGridCol>
          </>
        )}
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        {path === MODULES_LIST.STAFF && (
          <>
            <StyledGridCol lg={6}>
              <FormItem name="rank" label="Rank">
                <Select options={getOptionsFromRefList("Rank")} />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="division" label="Division">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="badge" label="Badge Number">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="username" label="User Name">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6} style={{ display: "flex", alignItems: "center" }}>
              <FormItem
                name="isActive"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Checkbox>Active</Checkbox>
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={6}>
              <FormItem name="agency" label="Agency">
                <Select options={getOptionsFromRefList("Housing_Agency")} />
              </FormItem>
            </StyledGridCol>
          </>
        )}
      </StyledGridRow>
    </>
  );
};

export default QuickSearchBookings;
